import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import withMainControls from 'eventbrite_design_system/structure/hoc/withMainControls';

import {
    location as locationDuck,
} from '@eb/destination-utils';

import SearchBaseScreen from '../components/SearchBaseScreen';
import {
    trackEventClickInternal as trackEventClickInternalAction,
    trackPageView as trackPageViewAction,
} from '../actions/analytics';
import {
    saveEvent as saveEventAction,
} from '../actions/event';
import {
    setSearchInformationFromUrl as setSearchInformationFromUrlAction,
} from '../actions/location';
import {
    handleApplyFilter as handleApplyFilterAction,
    handleRemoveFilter as handleRemoveFilterAction,
    updateSearchInformationFromUrl as updateSearchInformationFromUrlAction,
} from '../actions/search';

const {
    actions: {
        updateLocation: updateLocationAction,
    },
} = locationDuck;

const getSelectedFilterCount = (state) => {
    const {
        search: {
            eventSearch,
        },
    } = state;

    return (
        // Dates will be a string if no date is selected, else array
        // Dates always has at least "current_future" already, so don't count it
        (Array.isArray(eventSearch.dates) ? eventSearch.dates.length - 1 : 0) +
        // Categories and formats are both tags, and you can only select one of each right now
        eventSearch.tags.length +
        // Price is either empty string, paid or free
        (eventSearch.price !== '' ? 1 : 0)
    );
};

const getResetLink = (state) => `${state.app.serverUrl}/d/${state.location.slug}/all-events/`;

const _mapStateToProps = (state) => ({
    domain: state.app.domain,
    isAuthenticated: state.auth.isAuthenticated,
    currentPlace: state.location.currentPlace,
    currentPlaceParent: state.location.currentPlaceParent,
    placeType: state.location.placeType,
    isBotRequest: state.app.isBotRequest,
    userEmail: state.app.userEmail,
    selectedFilterCount: getSelectedFilterCount(state),
    resetLink: getResetLink(state),
    isFilterPanelMobileOpen: state.app.isFilterPanelMobileOpen,
});

const _mapDispatchToProps = (dispatch, ownProps) => ({
    handleApplyFilter: (...args) => dispatch(handleApplyFilterAction(ownProps.history, ...args)),
    handleRemoveFilter: (...args) => dispatch(handleRemoveFilterAction(ownProps.history, ...args)),
    onSaveEvent: (...args) => dispatch(saveEventAction(...args)),
    updateLocation: (...args) => dispatch(updateLocationAction(...args)),
    setSearchInformationFromUrl: (...args) => dispatch(setSearchInformationFromUrlAction(...args)),
    updateSearchInformationFromUrl: (...args) => dispatch(updateSearchInformationFromUrlAction(...args)),
    trackEventClickInternal: (...args) => dispatch(trackEventClickInternalAction(...args)),
    onTrackPageViewAction: (...args) => dispatch(trackPageViewAction(...args)),
});

export default withMainControls(withRouter(connect(
    _mapStateToProps,
    _mapDispatchToProps
)(SearchBaseScreen)));
